import axios from "axios";
import {
  UploadResponse,
  BatchResponse,
  FeedbackPayload,
} from "../types";

// Generated by GitHub Copilot
// Keep runtime API URL dynamic through .env.
export const API_BASE_URL =
  (process.env.REACT_APP_API_BASE_URL || "/api/v1").replace(/\/$/, "");

const BASE_URL = API_BASE_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Generated by GitHub Copilot
export const extractApiError = (err: unknown, fallback: string): string => {
  if (axios.isAxiosError(err)) {
    const detail = (err.response?.data as any)?.detail;
    if (typeof detail === "string" && detail.trim()) {
      return detail;
    }
    if (err.message) {
      return err.message;
    }
  }
  return fallback;
};

// Generated by GitHub Copilot
export const assertLlmConfigured = async (): Promise<void> => {
  await api.get("/llm/status");
};

// Generated by GitHub Copilot
export const assertLlmRuntimeReady = async (): Promise<void> => {
  await api.get("/llm/preflight");
};

// ── Manual Upload ──────────────────────────────────────────
export const uploadFile = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post("/manual/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// ── Approve / Push ─────────────────────────────────────────
export const approveMetadata = async (session_id: string) => {
  const res = await api.post("/approve", { session_id });
  return res.data;
};

// ── Push to Alation ────────────────────────────────────────
export const pushMetadata = async (session_id: string) => {
  const res = await api.post("/push", { session_id });
  return res.data;
};

// ── Skip File ──────────────────────────────────────────────
export const skipFile = async (thread_id: string) => {
  const res = await api.post("/batch/skip", { thread_id });
  return res.data;
};

// ── Batch Scan ─────────────────────────────────────────────
export const startBatch = async (blob_folder: string): Promise<BatchResponse> => {
  const res = await api.post(`/batch/start?blob_folder=${encodeURIComponent(blob_folder)}`);
  return res.data;
};

// ── Feedback ───────────────────────────────────────────────
export const submitFeedback = async (payload: FeedbackPayload) => {
  const res = await api.post("/feedback", payload);
  return res.data;
};

// ── Download ───────────────────────────────────────────────
export const downloadFile = async (session_id: string) => {
  const res = await api.get(`/download/${session_id}`, {
    responseType: "blob",
  });
  return res.data;
};